export class ResetPasswordEntryResult {
  isOk: boolean;
  isAccountCodeInvalid: boolean;
  isMailSendFailed: boolean;
}
